var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.imageUrl !== null)?_c('image-preview',{attrs:{"image-url":_vm.imageUrl,"title":_vm.tooltipLabel}}):_c('span',[_vm._v("-")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }